import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import sweetalert from './plugins/sweetalert';

Vue.config.productionTip = false
Vue.prototype.$window = window;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
